import { render, staticRenderFns } from "./tool-sub-menu.vue?vue&type=template&id=4b284412&"
import script from "./tool-sub-menu.vue?vue&type=script&lang=ts&"
export * from "./tool-sub-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports